/**
 * @generated SignedSource<<628878a89b3018b35dd55976914fd560>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type labelCategoryRow_labels$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string | null;
  readonly taskCount: number | null;
  readonly projectCount: number | null;
  readonly peopleCount: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"labelRow_label">;
  readonly " $fragmentType": "labelCategoryRow_labels";
}>;
export type labelCategoryRow_labels$key = ReadonlyArray<{
  readonly " $data"?: labelCategoryRow_labels$data;
  readonly " $fragmentSpreads": FragmentRefs<"labelCategoryRow_labels">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "labelCategoryRow_labels",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "peopleCount",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "labelRow_label"
    }
  ],
  "type": "Label",
  "abstractKey": null
};

(node as any).hash = "5fa515008c31079470fbe8e18f34c51a";

export default node;
